import {BASE_AGGREGATION} from 'pipelines/formula/functions/BaseFunctions';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  ...BASE_AGGREGATION,
  name: 'MIN',
  description:
    'Minimum of all numbers in a single column OR across each row of multiple columns. Single numbers are treated as columns containing only that number.',
  shortDescription: 'Minimum value',
} satisfies AnalysisFunction;
